import * as React from 'react';

import { mergeStyles } from '@cian/utils';

import { Button } from '../../button';
import { LikeButton } from '../like';

import * as styles from './index.css';

/**
 * Адаптивная кнопка избранного, которая схлопывается в иконку на разрешении width < 1240px
 */
export class AdaptiveLikeButton extends LikeButton {
  public render() {
    return (
      <Button
        theme="primary"
        mode="light"
        {...mergeStyles(
          styles['button'],
          this.props.buttonClassName || '',
          // tslint:disable-next-line:no-any
          !this.state.isActive && this.props.buttonStyle as any,
        )}
        onClick={this.handleClick}
      >
        <svg
          {...mergeStyles(
            styles['icon'],
            this.state.isActive && styles['icon--active'],
          )}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14.004 14"
          width="14"
          height="14"
        >
          {/* tslint:disable-next-line:max-line-length */}
          <path stroke="#E84260" strokeWidth="2" d="M6.99 11.72L1.825 6.677C.727 5.582.725 3.805 1.82 2.707l.015-.015c1.118-1.08 2.962-1.08 4.092.014l.36.35.67.648.694-.62.394-.35.03-.028c1.13-1.095 2.973-1.095 4.104 0 1.1 1.093 1.103 2.87.01 3.968l-.015.015-5.182 5.03z" />
        </svg>
        <div className={styles['button_text']}>
          {this.state.isActive ? 'В избранном' : 'В избранное'}
        </div>
      </Button>
    );
  }
}
